import ErrorFallback from 'Components/ErrorFallback'
import {
  ZoneCreatePage,
  ZoneEditPage,
  ZoneListPage
} from 'Services/ControlDataManagement/Features/Zone/Pages'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'

function ZoneRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<ZoneListPage />} />
        <Route path="create" element={<ZoneCreatePage />} />
        <Route path=":id/edit" element={<ZoneEditPage />} />
      </Routes>
    </ErrorBoundary>
  )
}

export default ZoneRoot
